module.exports = __webpack_public_path__ + "img/hide-displays.e422a360.svg";